import React, { useState } from 'react';
import { getPatientSafetySvg } from './patientSafetySvgTemplate';

const PatientSafetyCertificate = ({ user, date }) => {
    const [isDownloading, setIsDownloading] = useState(false);
    const svgHtml = getPatientSafetySvg(user, date);

    const handleDownloadPng = () => {
        setIsDownloading(true);
        try {
            // Encode SVG into base64 data URL
            const base64Svg = btoa(unescape(encodeURIComponent(svgHtml)));
            const dataUrl = 'data:image/svg+xml;base64,' + base64Svg;

            const img = new Image();
            img.onload = () => {
                try {
                    // Use 2x scale for crystal-clear, high-resolution PNG (2626 x 2066)
                    const scale = 2;
                    const canvas = document.createElement('canvas');
                    canvas.width = Math.round(1313.18 * scale);
                    canvas.height = Math.round(1033.23 * scale);
                    const ctx = canvas.getContext('2d');

                    // Pure white background for canvas
                    ctx.fillStyle = '#ffffff';
                    ctx.fillRect(0, 0, canvas.width, canvas.height);

                    // Draw image onto canvas
                    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

                    // Export to PNG
                    canvas.toBlob((pngBlob) => {
                        if (pngBlob) {
                            const pngUrl = URL.createObjectURL(pngBlob);
                            const downloadLink = document.createElement('a');
                            downloadLink.href = pngUrl;
                            downloadLink.download = `Patient_Safety_Certificate_${(user || 'Certificate').replace(/\s+/g, '_')}.png`;
                            document.body.appendChild(downloadLink);
                            downloadLink.click();
                            document.body.removeChild(downloadLink);
                            setTimeout(() => URL.revokeObjectURL(pngUrl), 2000);
                        }
                        setIsDownloading(false);
                    }, 'image/png');
                } catch (canvasErr) {
                    console.error('Canvas export error:', canvasErr);
                    setIsDownloading(false);
                }
            };
            img.onerror = (err) => {
                console.error('Image load error during PNG conversion:', err);
                setIsDownloading(false);
            };
            img.src = dataUrl;
        } catch (e) {
            console.error('PNG Download error:', e);
            setIsDownloading(false);
        }
    };

    const handlePrint = () => {
        try {
            const printWindow = window.open('', '_blank');
            if (printWindow) {
                printWindow.document.write(`
                    <!DOCTYPE html>
                    <html>
                    <head>
                        <title>Patient Safety Certificate - ${user || ''}</title>
                        <style>
                            @page { size: landscape; margin: 0; }
                            body { 
                                margin: 0; 
                                padding: 20px; 
                                display: flex; 
                                justify-content: center; 
                                align-items: center; 
                                background: #ffffff;
                                -webkit-print-color-adjust: exact;
                                print-color-adjust: exact;
                            }
                            svg { width: 100%; max-width: 1150px; height: auto; display: block; margin: auto; }
                        </style>
                    </head>
                    <body>
                        ${svgHtml}
                        <script>
                            window.onload = function() {
                                window.print();
                            };
                        </script>
                    </body>
                    </html>
                `);
                printWindow.document.close();
            }
        } catch (e) {
            console.error('Print error:', e);
        }
    };

    return (
        <div className="patient-safety-cert-card mb-4">
            <div
                className="patient-safety-svg-wrapper"
                dangerouslySetInnerHTML={{ __html: svgHtml }}
            />
            <div className="d-flex justify-content-center align-items-center mt-3" style={{ gap: '12px' }}>
                <button
                    type="button"
                    className="btn btn-primary btn-sm d-flex align-items-center shadow-sm"
                    onClick={handleDownloadPng}
                    disabled={isDownloading}
                    style={{
                        borderRadius: '20px',
                        padding: '8px 20px',
                        fontSize: '14px',
                        fontWeight: '600',
                        backgroundColor: '#6a0f82',
                        borderColor: '#6a0f82'
                    }}
                >
                    <i className={`fa ${isDownloading ? 'fa-spinner fa-spin' : 'fa-download'}`} style={{ marginRight: '8px' }} />
                    {isDownloading ? 'Generating PNG...' : 'Download PNG'}
                </button>
                <button
                    type="button"
                    className="btn btn-outline-secondary btn-sm d-flex align-items-center"
                    onClick={handlePrint}
                    style={{
                        borderRadius: '20px',
                        padding: '8px 18px',
                        fontSize: '14px',
                        fontWeight: '600',
                        borderColor: '#888',
                        color: '#444'
                    }}
                >
                    <i className="fa fa-print" style={{ marginRight: '8px' }} />
                    Print / PDF
                </button>
            </div>
        </div>
    );
};

export default PatientSafetyCertificate;
